import React, { memo } from "react";

/**
 * Shared Logo component for consistent branding across the app
 */
const Logo = memo(() => (
  <div className="w-full max-w-3xl mb-6 flex justify-center">
    <h1 className="text-4xl font-bold tracking-tight">
      <span className="text-accent animate-glow">HIGH</span>
      <span className="logo-text">LIGHTER</span>
      <img src="/fav.png" alt="" className="logo-icon" />
    </h1>
  </div>
));

Logo.displayName = 'Logo';

export default Logo;
